<div class="project-bulk-container">

  <form [formGroup]="formGroup">
    <div class="p-grid p-fluid">
      <div class="p-col-6 p-md-6 p-lg-6">
        <div class="label-container">
          <label class="label" for="user">Notes<span class="error-icon"><app-icon class="error-icon" iconName="question-circle" *ngIf="isShowNotes" [title]="notesErrorMessages"></app-icon></span></label>
        </div>
        <form-factory [formGroup]="formGroup" [model]="chasesNotes" (onInput)="checkNotes()"></form-factory>
      </div>
    </div>

    <div *ngIf="isBulkPendUpdate">
      <div class="p-grid p-fluid">
        <div class="p-col-3 p-md-3 p-lg-3">
          <form-factory [formGroup]="formGroup" [model]="invoiceNumberInput"></form-factory>
        </div>
      </div>

      <div class="p-grid p-fluid">
        <div class="p-col-3 p-md-3 p-lg-3">
          <form-factory [formGroup]="formGroup" [model]="invoiceAmountInput"></form-factory>
        </div>
      </div>

      <div class="p-grid p-fluid">
        <div class="p-col-3 p-md-3 p-lg-3">
          <form-factory [formGroup]="formGroup" [model]="pendCompanyInput"></form-factory>
        </div>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-12 p-lg-12">
        <app-button text="CONTINUE TO VALIDATION" (onClick)="validate()"></app-button>
      </div>
    </div>

  </form>

  <div class="p-grid p-fluid" *ngIf="isShowValidateGrid && !isDurableJobQueued">
    <div class="p-col-12 p-md-12 p-lg-12">
      <app-basic-grid [configuration]="serverGridConfiguration"
                       [data]="data">
      </app-basic-grid>
    </div>
    <div class="p-grid p-fluid finish-bulk-update-container">
      <div class="p-col-12 p-md-12 p-lg-12">
        <app-button (onClick)="confirmBulkUpdate()" text="FINISH BULK UPDATE" [disabled]="isFinalBulkUpdate"></app-button>
      </div>
    </div>
  </div>

  <div class="bulk-update-pend__notice" *ngIf="isDurableJobQueued">
    <app-icon iconName="info-circle" class="bulk-update-pend__notice-icon"></app-icon>
    <div>
      <div class="bulk-update-pend__notice-title bold">Bulk action submitted</div>
      <div>
        This bulk change involves a large number of pends, so it's being validated in the
        background. You'll receive a notification when validation finishes &mdash; open it to
        review the results and continue.
      </div>
    </div>
  </div>
</div>

<app-confirmation-modal
  class="confirmation"
  [(visible)]="isCancelConfirmationModalVisible"
  header="Close the Chase(s)?"
  (onYes)="finalBulkUpdate()"
  (onCancel)="cancelConfirmation($event)">
  Closing the Pend(s) will also close the associated Chase(s). Those chases will no longer continue to be worked. Do you want to proceed?
</app-confirmation-modal>

<app-confirmation-modal
  class="confirmation"
  [(visible)]="isResolveConfirmationModalVisible"
  header="Resolve the Pend(s)?"
  (onYes)="finalBulkUpdate()"
  (onCancel)="cancelConfirmation($event)">
  Resolving the Pend(s) will let work continue on the Chase(s). This should be done once the obstacle preventing the Chase(s) from advancing has been resolved. Do you want to proceed?
</app-confirmation-modal>


